var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2082 0.950195H28.9216L18.6242 12.787L30.7383 28.8941H21.2531L13.8239 19.1252L5.32321 28.8941H0.606988L11.6211 16.2334L0 0.950195H9.726L16.4413 9.87935L24.2082 0.950195ZM22.554 26.0567H25.1657L8.30685 3.63854H5.50416L22.554 26.0567Z",
    fill: "#A0A1A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.45506b7aa5b19c3217795d4587554c2e.svg";
export { ForwardRef as ReactComponent };